import { TaskListItem, TechnicianAppointmentsItem } from '@myapp/contract'
import { TechnicianInfo } from './TechnicianInfo'
import { TimelineTrack } from './TimelineTrack'
import { DayLevelTaskBanner } from './DayLevelTaskBanner'
import { useTaskRescheduleContext } from '../../../features/task-reschedule'
import { useTimelineConfig } from '../model/TimelineConfigContext'
import { useTimelineRowData } from '../model/TimelineRowDataContext'

const ROW_BASE_HEIGHT = 64

interface Props {
  item: TechnicianAppointmentsItem
  dayLevelTasks?: TaskListItem[]
}

export const TechnicianRow = ({ item, dayLevelTasks }: Props) => {
  const { onTaskClick, isReadonly } = useTimelineConfig()
  const { taskDragState, startTaskDrag } = useTaskRescheduleContext()
  const { maxLaneCount } = useTimelineRowData()

  const isDraggingErrands = taskDragState != null && taskDragState.taskType === 'ERRANDS'
  const showDropZone = isDraggingErrands && !isReadonly
  const isDayLevelGhostHere = taskDragState?.isDayLevel && taskDragState.currentTechnicianId === item.technicianId

  return (
    <div className="w-full flex items-stretch">
      <TechnicianInfo
        technicianId={item.technicianId}
        technicianName={item.technicianName}
        technicianRoles={item.technicianRoles}
        technicianAvatar={item.technicianAvatar}
      />
      <div className="flex-1 min-w-0 flex flex-col">
        {dayLevelTasks?.map((task) => (
          <DayLevelTaskBanner
            key={task.id}
            task={task}
            onClick={() => onTaskClick(task.id)}
            onDragStart={!isReadonly ? (t, e) => startTaskDrag(t, item.technicianId, e) : undefined}
            isDragging={taskDragState?.taskId === task.id}
          />
        ))}
        {showDropZone && (
          <div
            data-day-level-zone
            data-technician-id={item.technicianId}
            className={`flex items-center px-3 h-6 text-xs font-medium border border-dashed transition-colors select-none ${
              isDayLevelGhostHere
                ? 'border-blue-400 bg-blue-50 text-blue-600'
                : 'border-slate-300 bg-slate-50 text-slate-400'
            }`}
          >
            {isDayLevelGhostHere && taskDragState
              ? `↑ Ganztag: ${taskDragState.taskTitle}`
              : 'Ganztag'}
          </div>
        )}
        <div className="flex items-stretch" style={{ height: ROW_BASE_HEIGHT * maxLaneCount }}>
          <TimelineTrack />
        </div>
      </div>
    </div>
  )
}
